
    import '/home/ec2-user/Youlify-Design/components/rate/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["rate-demo-basic","rate-demo-half","rate-demo-text","rate-demo-disabled","rate-demo-clear","rate-demo-character","rate-demo-character-function","rate-demo-component-token"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/home/ec2-user/Youlify-Design/components/rate/index.en-US.md?type=demo')
};